var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestToProvider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.76108H4C2.9 4.76108 2.01 5.66108 2.01 6.76108L2 18.7611C2 19.8611 2.9 20.7611 4 20.7611H20C21.1 20.7611 22 19.8611 22 18.7611V6.76108C22 5.66108 21.1 4.76108 20 4.76108ZM20 8.76108L12 13.7611L4 8.76108V6.76108L12 11.7611L20 6.76108V8.76108Z",
    fill: "#E33AA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestToProvider);
export default __webpack_public_path__ + "static/media/requestToProvider.eb047891414cbaecbf84947c103198bb.svg";
export { ForwardRef as ReactComponent };